// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"b43c5ef7","54":"289381e4","125":"344d463c","233":"02bb35b2","513":"cc0db1fa","771":"eace69ad","933":"3e1ef9f1"}[chunkId] + ".chunk.js";
};